import React from 'react';

export const PhieuIn = React.forwardRef(({ htmlContent }, ref) => {
    return (
        <div ref={ref} dangerouslySetInnerHTML={{ __html: htmlContent }} />
    );
});